import { createFileRoute } from '@tanstack/react-router';
import { AgencyDashboardPage } from '../features/agency/AgencyDashboardPage/AgencyDashboardPage';
import { dashboardRouteSearchSchema } from '../features/dashboard/dashboardRouteSearch';
export const Route = createFileRoute('/a/$agencyId')({
  validateSearch: dashboardRouteSearchSchema,
  component: AgencyDashboardRoute,
});
function AgencyDashboardRoute() {
  const { agencyId } = Route.useParams();
  return <AgencyDashboardPage key={agencyId} agencyId={agencyId} />;
}
